import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, Container, Card, Button } from 'react-bootstrap';
import '../../../CommonCSS/SocietyCSS.css';
import { exportCGExcel } from "./ExportCGExcel";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ChartGroup = () => {

  const [reportData, setReportData] = useState([]);
  const [groupedData, setGroupedData] = useState([]);
  const [expandedMainGroups, setExpandedMainGroups] = useState({});
  const [expandedGroups, setExpandedGroups] = useState({});
  const [societyName, setSocietyName] = useState();

  useEffect(() => {
    fetchReportData();
  }, []);

  const fetchReportData = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/rpt_ChartGroups`);
      if (res.data.length > 0) {
        setReportData(res.data);
        const grouped = groupData(res.data);
        setGroupedData(grouped);
        setSocietyName(res.data[0].scty_name);
      } else {
        setGroupedData([]);
      }
    } catch (err) {
      console.error("Error fetching report data:", err);
    }
  };

  // Group and map data for drill-down
  const groupData = (data) => {
    const result = [];
    let currentMain = null;
    let currentGroup = null;

    data.forEach((row) => {
      // Main Group
      if (!currentMain || currentMain !== row.main_grp_desc) {
        currentMain = row.main_grp_desc;
        result.push({ type: "main", label: currentMain, key: currentMain });
      }

      // Group (Level-2)
      if (!currentGroup || currentGroup !== row.grp_desc) {
        currentGroup = row.grp_desc;
        result.push({
          type: "group",
          label: currentGroup,
          order_pl: row.lvl2_ord_pl,  // updated
          order_bl: row.lvl2_ord_bl,  // updated
          schedule: row.schedule,
          mainKey: currentMain,
          key: currentMain + "-" + currentGroup,
        });
      }

      // Sub-Group (Level-3)
      if (row.sub_grp_desc) {
        result.push({
          type: "sub",
          label: row.sub_grp_desc,
          order_pl: row.lvl3_ord_pl,  // updated
          order_bl: row.lvl3_ord_bl,  // updated
          groupKey: currentMain + "-" + currentGroup,
        });
      }
    });

    return result;
  };

  // const toggleMainGroup = (key) => {
  //   setExpandedMainGroups(prev => ({
  //     ...prev,
  //     [key]: !prev[key],
  //   }));
  // };

  const toggleMainGroup = (key) => {
    setExpandedMainGroups(prev => {
      const newState = {
        ...prev,
        [key]: !prev[key],
      };

      // If collapsing the main group, also collapse all its child groups
      if (prev[key]) {
        setExpandedGroups(oldGroups => {
          const newGroups = { ...oldGroups };
          Object.keys(newGroups).forEach(groupKey => {
            if (groupKey.startsWith(key + "-")) {
              delete newGroups[groupKey];
            }
          });
          return newGroups;
        });
      }

      return newState;
    });
  };

  const toggleGroup = (key) => {
    setExpandedGroups(prev => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <Container fluid className="p-3">
      <Card className="mb-3 p-2">
        <Row>
          <Col className="text-end">
            <Button className="me-2" variant="success" onClick={fetchReportData}>Refresh</Button>
            <Button className="me-2" variant="secondary" onClick={() => exportCGExcel({ groupedData, societyName })}
               disabled={groupedData.length === 0}>Excel file</Button>
          </Col>
        </Row>
      </Card>

      <Card className="p-3">
        <div style={{ minHeight: '220px' }} className="table-responsive">
          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table-rcpt hover-table-rcpt">
            <thead className="table-light">
              <tr>
                <th style={{ width: "30%" }}>Description</th>
                <th style={{ width: "10%" }}>Order PL</th>
                <th style={{ width: "10%" }}>Order BL</th>
                <th style={{ width: "10%" }}>Schedule</th>
              </tr>
            </thead>
            <tbody>
              {groupedData.map((row, idx) => {
                if (row.type === "main") {
                  return (
                    <tr key={idx} style={{ fontWeight: "bold", backgroundColor: "#CCCCFF", color: "white", cursor: 'pointer' }}
                        onClick={() => toggleMainGroup(row.key)}>
                      <td colSpan="4">
                        {expandedMainGroups[row.key] ? "▼ " : "► "} {row.label}
                      </td>
                    </tr>
                  );
                }

                if (row.type === "group") {
                  if (!expandedMainGroups[row.mainKey]) return null; // hide group if main collapsed
                  return (
                    <tr key={idx} style={{ fontWeight: "bold", backgroundColor: "#D8BFD8", cursor: 'pointer' }}
                        onClick={() => toggleGroup(row.key)}>
                      <td>
                        <span style={{ paddingLeft: '30px', display: 'inline-block' }}>
                          {expandedGroups[row.key] ? "▼ " : "► "} {row.label}
                        </span>
                      </td>
                      <td>{row.order_pl}</td>
                      <td>{row.order_bl}</td>
                      <td>{row.schedule}</td>
                    </tr>
                  );
                }

                if (row.type === "sub") {
                  if (!expandedGroups[row.groupKey]) return null; // hide sub if group collapsed
                  return (
                    <tr key={idx}>
                      <td>
                        <span style={{ paddingLeft: '50px', display: 'inline-block' }}>
                          {row.label}
                        </span>
                      </td>
                      <td>{row.order_pl}</td>
                      <td>{row.order_bl}</td>
                      <td></td>
                    </tr>
                  );
                }

                return null;
              })}
            </tbody>
          </table>
        </div>
      </Card>
    </Container>
  );
};

export default ChartGroup;
